import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, UiButton, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {ELEVATE_LINK} from '~/constants';
import {useNotification} from '~/hooks';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {redirectInIframe} from '~/utils/helpers';
const queryString = require('query-string');

interface RouteParams {
  status: string;
}

interface Props {}

const messageContent = {
  SUBMITTED: {
    subject: 'Your renewal form has been submitted.',
    content: 'If you require any assistance, please reach out to us at hello@tryelevate.sg',
  },
  EXPIRED: {
    subject: 'Oops, the renewal form you followed is invalid',
    content: 'If you require any assistance, please reach out to us at hello@tryelevate.sg',
  },
};

const MDQRenewalQuestionnaireInvalidScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const location = window.location;
  const query: RouteParams = queryString.parse(location.search);
  const {methodKey, medicalUUID, answerOrder, collectedData} = mdq;
  const {addMessage} = useNotification(dispatch);
  const isSubmitted = query.status === 'submitted';
  const [redirectLoading, setRedirectLoading] = useState(false);

  const messageContentToShow = isSubmitted ? messageContent.SUBMITTED : messageContent.EXPIRED;

  const renderParseText = (text: string) => {
    const emailRegex = /\S+@\S+\.\S+/;
    const parts = text.split(emailRegex);

    if (parts.length === 2) {
      const email = text.match(emailRegex);
      return (
        <>
          {parts[0]}
          <a href={`mailto:${email}`} style={{color: '#2C4142CC'}}>
            {email}
          </a>
          {parts[1]}
        </>
      );
    }

    return text;
  };

  const onClickSubmit = () => {
    setRedirectLoading(true);
    redirectInIframe(ELEVATE_LINK, '_blank');
  };

  return (
    <UiQuestionnaireLayout showBackButton={false} isFirstScreen pageTitle="MDQ Renewal - Expired or Submitted">
      <Col textAlign="center" mt={36} mb={1} alignItems="center">
        <UiText fontSize="xl" fontWeight="bold" mb={6} mt={6} maxW="90%">
          {messageContentToShow.subject}
        </UiText>
        <UiText fontSize="sm" fontWeight="500" color="liteOuter" maxW="90%">
          {renderParseText(messageContentToShow.content)}
        </UiText>
        <Col alignItems="center" justifyContent="center" w="100%" mt={8}>
          <UiButton isLoading={redirectLoading} onClick={onClickSubmit} w="55%" variant="primary">
            Return to website
          </UiButton>
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default MDQRenewalQuestionnaireInvalidScreen;
